module.exports = __webpack_public_path__ + "static/media/mmg_kelly_rosser.ec5e102d.jpg";